(function ($, Drupal, once) {

  'use strict';

  const container = document.querySelector('.js-sticky-container');

  const scroll = document.querySelector('.js-sticky-scroll');
  const targetID = scroll?.dataset?.scrollTo !== undefined ? scroll?.dataset?.scrollTo : scroll?.getAttribute('href');
  var target = targetID?.startsWith("#") ? document.querySelector(targetID) : null;

  const originalParentElement = Symbol();
  const originalNextElementSibling = Symbol();

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Drupal.behaviors.promutuel_sticky = {
    attach: function attach(context) {

      // On hub and job type pages, the bar scrolls and sticks to an element.
      $(once('promutuelStickyBarSizeHandler', scroll, context)).each(function () {
        if (target) {
          target.addEventListener('viewportenteratbottom', _ => {
            unstickBarFromViewport();
          });
          target.addEventListener('viewportleaveatbottom', _ => {
            stickBarToViewport();
          });
          Promutuel.windowing.enableViewportEvents(target);

          // Check if the bar should be immediately unstuck (for instance if the page is
          // reloaded after being scrolled down).
          const currentPos = Promutuel.windowing.whereIsElementY(target);
          if (currentPos === Promutuel.windowing.POSITIONS.WITHIN_VIEWPORT || currentPos === Promutuel.windowing.POSITIONS.BEFORE_VIEWPORT_START) {
            unstickBarFromViewport();
          }
        }

        // Scroll event listener.
        scroll.addEventListener('click', function (event) {
          if (target) {
            window.scrollTo({
              top: target.getBoundingClientRect().top
                + window.scrollY
                - container.offsetHeight
                - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-adminoffset')) || 0),
              behavior: 'smooth'
            });
          }
        });
      });

      // On job posting pages, there is a back button to return to the list view.
      $(once('promutuelStickyBarBackButton', '.js-sticky-back', context)).each(function () {
        let lastViewUrl;
        try {
          lastViewUrl = JSON.parse(Promutuel.cookies.getSingleValue('pm_job_listing'))?.url;
        }
        catch(error) {}
        finally {
          lastViewUrl = lastViewUrl ?? drupalSettings.path.careerHubUrl;
        }

        const fragment = this.href.split('#')?.[1] ?? '';
        this.href = `${lastViewUrl}#${fragment}`;

      });
      
      $(once('promutuelStickyBarSizeHandler', '.js-sticky-container', context)).each(function() {
        // Add extra padding on the footer to accommodate the sticky bar.
        if (target === null) {
          document.querySelector('.footer__bottom').classList.add('footer__bottom--sticky-bar');
        }
      });
    }
  };

  let isBarCurrentlySticky = true;

  /**
   * Sends the bar to the top of the target, and make it static (so it scrolls along
   * with the page contents).
   */
  function unstickBarFromViewport() {
    // Prevent double calls.
    if (!isBarCurrentlySticky) return;
    isBarCurrentlySticky = false;

    // Memorize the original position of the bar in the DOM.
    if (!container[originalParentElement]) {
      container[originalParentElement] = container.parentElement;
      container[originalNextElementSibling] = container.nextElementSibling;
    }

    if (!target) return;
    target.insertAdjacentElement('afterBegin', container);
    target.style.position = 'relative';

    container.style.position = 'absolute';
    container.style.top = `-${container.offsetHeight}px`;
    container.style.height = '0';
  }

  function stickBarToViewport() {
    // Prevent double calls.
    if (isBarCurrentlySticky) return;
    isBarCurrentlySticky = true;

    container[originalParentElement].insertBefore(container, container[originalNextElementSibling]);
    container.style.position = '';
    container.style.top = '';
    container.style.height = '';
  }

})(jQuery, Drupal, once);
